// extracted by mini-css-extract-plugin
export default {"container":"cpwnl6ur5"};